import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Demo from './components/Demo';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import NotFound from './components/NotFound';

// Quick Translator Components
import TranslatorHero from './components/translator/TranslatorHero';
import TranslatorFeatures from './components/translator/TranslatorFeatures';
import TranslatorDemo from './components/translator/TranslatorDemo';
import TranslatorPrivacy from './components/translator/TranslatorPrivacy';

// Tomo Components
import TomoHero from './components/tomo/TomoHero';
import TomoFeatures from './components/tomo/TomoFeatures';
import TomoPrivacy from './components/tomo/TomoPrivacy';

// App Selector
import AppSelector from './components/AppSelector';

// Favicon Handler
import FaviconHandler from './components/FaviconHandler';

function App() {
  return (
    <Router>
      <FaviconHandler />
      <div className="min-h-screen">
        <Routes>
          {/* App Selector Home Page */}
          <Route path="/" element={<AppSelector />} />

          {/* PDF Viewer Website Routes */}
          <Route path="/pdf" element={
            <div className="bg-gradient-to-br from-secondary-50 to-white">
              <Navbar />
              <Hero />
              <Features />
              <Demo />
              <Footer />
            </div>
          } />
          <Route path="/pdf/privacy" element={
            <div className="bg-gradient-to-br from-secondary-50 to-white">
              <Navbar />
              <Privacy />
              <Footer />
            </div>
          } />
          {/* Legacy route for PDF Viewer privacy */}
          <Route path="/privacy" element={
            <div className="bg-gradient-to-br from-secondary-50 to-white">
              <Navbar />
              <Privacy />
              <Footer />
            </div>
          } />

          {/* Quick Translator Website Routes */}
          <Route path="/translator" element={
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50">
              <Navbar isTranslator={true} />
              <TranslatorHero />
              <TranslatorFeatures />
              <TranslatorDemo />
              <Footer isTranslator={true} />
            </div>
          } />
          <Route path="/translator/privacy" element={
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50">
              <Navbar isTranslator={true} />
              <TranslatorPrivacy />
              <Footer isTranslator={true} />
            </div>
          } />

          {/* Tomo Website Routes */}
          <Route path="/tomo" element={
            <div className="bg-gradient-to-br from-amber-50 to-rose-50">
              <Navbar isTomo={true} />
              <TomoHero />
              <TomoFeatures />
              <Footer isTomo={true} />
            </div>
          } />
          <Route path="/tomo/privacy" element={
            <div className="bg-gradient-to-br from-amber-50 to-rose-50">
              <Navbar isTomo={true} />
              <TomoPrivacy />
              <Footer isTomo={true} />
            </div>
          } />

          {/* 404 Page */}
          <Route path="*" element={
            <div className="bg-gradient-to-br from-secondary-50 to-white">
              <Navbar />
              <NotFound />
              <Footer />
            </div>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 